import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { SubmitTrainingItemEvaluationCommand } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const educationalAdvisorSubmitTrainingItemEvaluation = createAsyncThunk<
  void,
  SubmitTrainingItemEvaluationCommand,
  { extra: Partial<Dependencies> }
>(
  "educationalAdvisor/submitTrainingItemEvaluation",
  async (command: SubmitTrainingItemEvaluationCommand, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.submitTrainingItemEvaluation(command);
  },
);

export const resetEducationalAdvisorSubmitTrainingItemEvaluation = createAction("educationalAdvisor/resetSubmitTrainingItemEvaluation");
